import React from 'react';
import AppLayout from '../../components/AppLayout';
import OverviewList from '../../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,
        Segment,LoadGraphic,Step,DynamicListArea,BulkEdit} from '../../components/Common';
import {Input,Button,Area} from '../../components/Input';
import u from '../../utilities/Utilities';
import {Link} from 'react-router-dom';
import moment from 'moment';

export default class StoreActivityList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Store Activity",
        permission:"inventory",  //Accepts combined permission module as well
        //combinedField:"price",     //Used when permission exists in a combined field
        url:"/store-activity-list",

        /**** Action Setup ****/
        addType:1,
        addURL:"/api/add-store-activity-entry",
        //templateURL:"/api/get-add-tenant-template",
        //bulkURL:"/api/add-bulk-tenants",
        deleteURL:"/api/delete-store-activity-entries",
        spreadsheetURL:"/api/generate-store-activity-spreadsheet",
        overviewURL:"/api/get-all-store-activity-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"store-activity-list",
        orderByField:"createdOn",
        orderByType:"descending",
        disableChild:true,
        timeModeField:"activity",
        timeMode:true,
        timeModeDateField:"createdOn",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        //add:{component:AddExitRequestEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
        options:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (bulkEditOptions.length > 0 && (permissions.update));
        this.setState({
            pageMenuButtons:[
                //{label:"Add Entry",ref:"add",image:"/images/page-menu/add.png",title:"Add new entry",enabled:(permissions.create)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ],
            permissions:permissions,
        });
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    getActivity=(content)=>{
        const drawEntity = {
            "Asset Location":<Link to={"/estate-list/asset/"+content.drawEntityID}>Asset {content.drawEntityName}</Link>,
            "Room":<Link to={"/estate-list/room/"+content.drawEntityID}>Room {content.drawEntityName}</Link>,
            "Staff":<Link to={"/staff/"+content.drawEntityID}>Staff {content.drawEntityName}</Link>,
        };

        const storeEntity=<Link to={"/staff/"+content.storeStaffID}>{content.storeStaffName}</Link>;

        const item=<Link to={"/store-item?tags=@itemCode("+content.itemCode+")"}>{content.itemName}</Link>;

        const script = {
            "Transfer":<span>{storeEntity} transferred {content.quantity} x {item} ({content.itemCode}) to {drawEntity[content.drawEntityType]}</span>,
            "Return":<span>{drawEntity[content.drawEntityType]} returned {content.quantity} x {item} ({content.itemCode}) to the store via {content.storeStaffName}</span>,
            "Condemn":<span>{storeEntity} condemned {content.quantity} x {item} ({content.itemCode})</span>,
            "Missing":<span>{storeEntity} marks {content.quantity} x {item} ({content.itemCode}) as missing</span>,
            "Disposal":<span>{storeEntity} marks {content.quantity} x condemned {item} ({content.itemCode}) as disposed</span>,
        };
        
        return script[content.activityType];
    };

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <div>{this.getActivity(content)}</div>
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}
